export const setLangAttribute = (langArg: string | undefined | null): string => {
  if (langArg === 'en' || langArg === 'es') {
    return langArg
  } else {
    return 'en'
  }
}
